<template>
    <div class="container">
        <div class="nav_header">
            <h2>交易流水</h2>
        </div>

        <el-select v-model="type" size="medium" @change="onObjectChange" style="width:110px;margin-right:12px">
            <el-option value="" label="交易类型"></el-option>
            <el-option value="recharge" label="充值"></el-option>
            <el-option value="refund" label="退款"></el-option>
            <el-option value="resource_deposit" label="订单定金"></el-option>
            <el-option value="resource_balance" label="订单尾款"></el-option>
        </el-select>

        <el-date-picker
            @change="handleDateChange"
            v-model="dateBetween"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="picker_options"
        >
        </el-date-picker>

        <white-space />

        <div v-loading="loading">
            <el-table v-loading="loading" :data="data_source">
                <el-table-column prop="transaction_no" label="流水号" width="200">
                    <!-- <template slot-scope="scope">
                        <router-link :to="'/finance/transaction/' + scope.row.transaction_no" class="link">{{
                            scope.row.transaction_no
                        }}</router-link>
                    </template> -->
                </el-table-column>

                <el-table-column prop="object_text" label="交易类型" width="80">
                    <template slot-scope="scope">
                        <span v-if="['recharge', 'income'].indexOf(scope.row.object) > -1" style="color:#67c23a;">
                            {{ scope.row.object_text }}
                        </span>
                        <span v-else style="color:#f56c6c;">
                            {{ scope.row.object_text }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="name" label="交易项目" width="150">
                    <div slot-scope="scope">
                        {{ scope.row.name }}
                    </div>
                </el-table-column>

                <el-table-column prop="amount" label="交易金额">
                    <template slot-scope="scope">
                        <span v-if="['recharge', 'income'].indexOf(scope.row.object) > -1" style="color:#67c23a;">
                            <span style="width: 20px;">+</span>
                            ￥{{ scope.row.amount }}
                        </span>
                        <span v-else style="color:#f56c6c;">
                            <span style="width: 20px;">-</span>
                            ￥{{ scope.row.amount }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="channel_text" label="支付方式"> </el-table-column>

                <el-table-column prop="member_balance" label="交易后余额">
                    <template slot-scope="scope"> {{ wan(scope.row.member_balance) }} </template>
                </el-table-column>

                <el-table-column prop="created_at" label="交易时间" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.created_at | dateformat("YYYY-MM-DD HH:mm") }}
                    </template>
                </el-table-column>

                <!-- <el-table-column width="80" label="交易状态">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.paid_at">成功</el-tag>
                </template>
            </el-table-column> -->
            </el-table>
        </div>

        <el-pagination
            style="text-align:center;margin-top:24px;"
            background
            layout="total,prev, pager, next"
            :total="pagination.total"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            @current-change="handle_current_change"
        >
        </el-pagination>
    </div>
</template>

<script>
    import moment from "moment";
    var requestUrl = "/finance/transaction";

    export default {
        data() {
            return {
                path: "/finance/transaction",
                data_source: [],
                loading: false,
                showMore: [],
                type: "",
                dateBetween: "",
            };
        },
        created() {
            this.$store.commit("changeOwnActive", "finance-transaction");
            this.load();
            this.parse_query();
        },
        watch: {
            $route() {
                this.load();
                this.parse_query();
            },
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/finance/transaction?" + this.objectToQuery(this.$route.query))
                    .then((response) => {
                        if (response.success) {
                            this.data_source = response.data;

                            this.pagination = response.pagination;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            parse_query() {
                const query = this.$route.query;
                this.dateBetween = query["paid_at"] ? query["paid_at"].split(",") : "";
                this.type = query["type"] ? query["type"] : "";
            },

            handleDateChange() {
                var query = JSON.parse(JSON.stringify(this.$route.query));
                query["paid_at"] = this.dateBetween ? this.dateBetween.join(",") : "";
                query["_search"] = 1;

                this.$router.push(`/finance/transaction?${this.objectToQuery(query)}`);
            },
            onObjectChange(e) {
                var query = JSON.parse(JSON.stringify(this.$route.query));
                query.type = e;
                this.$router.push("/finance/transaction?" + this.objectToQuery(query));
            },
            handle_current_change(e) {
                var query = JSON.parse(JSON.stringify(this.$route.query));
                query.page = e;
                this.$router.push("/finance/transaction?" + this.objectToQuery(query));
            },
            onTaxonomyChange(e) {
                var query = JSON.parse(JSON.stringify(this.$route.query));
                query.taxonomy = e;
                this.$router.push("/finance/transaction?" + this.objectToQuery(query));
            },
        },
    };
</script>
